import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AuthProvider from './contexts/AuthProvider';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import SSOCallback from './pages/SSOCallback';
import Dashboard from './pages/Dashboard';
import Competitors from './pages/Competitors';
import CompetitorDetail from './pages/CompetitorDetail';
import Brands from './pages/Brands';
import KeywordResearch from './pages/KeywordResearch';
import './App.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sso-callback" element={<SSOCallback />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/competitors"
              element={
                <PrivateRoute>
                  <Competitors />
                </PrivateRoute>
              }
            />
            <Route
              path="/competitors/:id"
              element={
                <PrivateRoute>
                  <CompetitorDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/brands"
              element={
                <PrivateRoute>
                  <Brands />
                </PrivateRoute>
              }
            />
            <Route
              path="/keyword-research"
              element={
                <PrivateRoute>
                  <KeywordResearch />
                </PrivateRoute>
              }
            />

            <Route path="/" element={<Navigate to="/competitors" replace />} />
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
